export default __webpack_public_path__ + "static/media/p22.188b143c.JPG";